<div mat-dialog-title class="flex flex-row">
    Comprovante Cartão
    <div class="flex-fill"></div>
    <div class="btn-options">
        <button color="primary" (click)="dialogRef.close()" mat-icon-button matTooltip="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-content>
    <div class="flex flex-column align-center">
        <div [innerHTML]="comprovante | safeHtml"></div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button (click)="imprimirComprovante()" color="primary">Imprimir</button>
</div>
